import { IdifyParam } from './interfaces/idify.interface';

export const idify = (item: IdifyParam | string): string | undefined => {
  if (typeof item === 'string') {
    return item;
  }

  if (item) {
    return item.id || item._id;
  }

  return undefined;
};
